import { useTranslation } from 'react-i18next'
import { Row } from '~/components/Layout'
import { Container, StyledLabel, StyledGreenShield } from './styled'
import { formatFormAmount } from '~/utils/numbers'
import { useModalToggle } from '~/state/application/hooks'
import { ApplicationModal } from '~/state/application/reducer'
import { useSpotSwapPair } from '~/state/dex/hooks'
import IconGreenShield from '~/assets/images/greenShield.svg'
import Skeleton from '~/components/Skeleton'
import { useIsIMWallet, useUpdaterChainId } from '~/hooks'
import { useIsSendByRelayer } from '~/components/Exchange/hooks'
import { StyledDetailValue } from '~/components/Exchange/components/OrderPreview/styled'
import { formatUnits } from 'viem'
import { isMainnetOrSepolia } from '~/utils/chain'

interface MinReceivedProps {
  amount: bigint
  loading: boolean
}

const MinReceived: React.FC<MinReceivedProps> = ({ amount, loading }) => {
  const { t } = useTranslation()
  const updaterChainId = useUpdaterChainId()
  const isIMWallet = useIsIMWallet()
  const isSendByRelayer = useIsSendByRelayer()
  const [, outputToken] = useSpotSwapPair()

  const toggleModal = useModalToggle(ApplicationModal.SWAP_PROTECTION_INTRO, {
    stack: true,
  })

  const showShield =
    (isSendByRelayer || isIMWallet) && isMainnetOrSepolia(updaterChainId)

  return (
    <Container>
      <Row width="auto" align="center">
        <StyledLabel>{t('min_received')}</StyledLabel>
        {showShield && (
          <StyledGreenShield
            src={IconGreenShield}
            alt="greenShield"
            onClick={toggleModal}
          />
        )}
      </Row>
      {loading ? (
        <Skeleton />
      ) : (
        <StyledDetailValue>
          {formatFormAmount(formatUnits(BigInt(amount), outputToken?.decimals))}
        </StyledDetailValue>
      )}
    </Container>
  )
}

export default MinReceived
